// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#micId {
  margin-top: 10px;
  margin-bottom: 10px;
  size: 20;
  width: 50%;
  border-radius: 5px;
  /* height: ; */
}

#smartphoneCheckbox {
  margin-right: 5px;
  margin-left: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid black;
  background-color: white;
  vertical-align: middle;
  display: inline-block;
  position: relative;
  top: 2px;
}

#usbCheckbox {
  margin-right: 5px;
  margin-left: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid black;
  background-color: white;
  vertical-align: middle;
  display: inline-block;
  position: relative;
  top: 2px;
}

#manufacturerInput {
  width: 30vw;
  height: 45px;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}
#modelNumberInput {
  width: 30vw;
  height: 45px;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}

#modelNameInput {
  width: 30vw;
  height: 45px;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}
#brandInput {
  width: 30vw;
  height: 45px;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}
/* Style the autocomplete container */
.autocomplete {
  position: relative;
  display: inline-block;
  z-index: 9999;
}

/* Style the autocomplete input field */
input {
  padding: 10px;
  width: 300px;
  z-index: 9999;
}

/* Style the autocomplete dropdown list */
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  max-height: 150px;
  overflow-y: auto;
  z-index: 9999;
  background-color: white;
}

/* Style the individual autocomplete items */
.autocomplete-item {
  padding: 10px;
  cursor: pointer;
  z-index: 9999;
}

/* Highlight the matching part of the suggestion */
.highlight {
  font-weight: bold;
  color: blue;
}

.highlight-red {
  font-weight: bold;
  color: red;
}

#loudspeakerInstructions1 {
  /*   instructions.style.width = "100%";
  instructions.style.fontSize = "1.1rem";
  instructions.style.fontWeight = "normal"; */
  width: 100%;
  font-size: 1rem;
  font-weight: normal;
}

#micDropdown {
  width: fit-content;
  font-size: 1rem;
  border-radius: 5px;
  border: none;
  background-color: #dddddd;
  padding: 10px;
}

#micNameInput {
  width: 30vw;
  height: 100%;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}

#micManufacturerInput {
  width: 30vw;
  height: 100%;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}

#micSerialNumberInput {
  width: 30vw;
  height: 100%;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}

#modelNumberInput2 {
  width: 30vw;
  height: 100%;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}

#modelNameInput2 {
  width: 30vw;
  height: 100%;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid black;
  margin-top: 10px;
  margin-bottom: 10px;
}

#loudspeakerInstructions2 {
  font-size: 1rem;
  font-weight: normal;
  margin-top: 10px;
}

#completeTransducerTable {
  border-collapse: collapse;
}
`, "",{"version":3,"sources":["webpack://./components/css/soundCalibration.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;;6CAE2C;EAC3C,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["#micId {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  size: 20;\n  width: 50%;\n  border-radius: 5px;\n  /* height: ; */\n}\n\n#smartphoneCheckbox {\n  margin-right: 5px;\n  margin-left: 5px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  width: 20px;\n  height: 20px;\n  border-radius: 5px;\n  border: 1px solid black;\n  background-color: white;\n  vertical-align: middle;\n  display: inline-block;\n  position: relative;\n  top: 2px;\n}\n\n#usbCheckbox {\n  margin-right: 5px;\n  margin-left: 5px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  width: 20px;\n  height: 20px;\n  border-radius: 5px;\n  border: 1px solid black;\n  background-color: white;\n  vertical-align: middle;\n  display: inline-block;\n  position: relative;\n  top: 2px;\n}\n\n#manufacturerInput {\n  width: 30vw;\n  height: 45px;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n#modelNumberInput {\n  width: 30vw;\n  height: 45px;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n#modelNameInput {\n  width: 30vw;\n  height: 45px;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n#brandInput {\n  width: 30vw;\n  height: 45px;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n/* Style the autocomplete container */\n.autocomplete {\n  position: relative;\n  display: inline-block;\n  z-index: 9999;\n}\n\n/* Style the autocomplete input field */\ninput {\n  padding: 10px;\n  width: 300px;\n  z-index: 9999;\n}\n\n/* Style the autocomplete dropdown list */\n.autocomplete-items {\n  position: absolute;\n  border: 1px solid #d4d4d4;\n  max-height: 150px;\n  overflow-y: auto;\n  z-index: 9999;\n  background-color: white;\n}\n\n/* Style the individual autocomplete items */\n.autocomplete-item {\n  padding: 10px;\n  cursor: pointer;\n  z-index: 9999;\n}\n\n/* Highlight the matching part of the suggestion */\n.highlight {\n  font-weight: bold;\n  color: blue;\n}\n\n.highlight-red {\n  font-weight: bold;\n  color: red;\n}\n\n#loudspeakerInstructions1 {\n  /*   instructions.style.width = \"100%\";\n  instructions.style.fontSize = \"1.1rem\";\n  instructions.style.fontWeight = \"normal\"; */\n  width: 100%;\n  font-size: 1rem;\n  font-weight: normal;\n}\n\n#micDropdown {\n  width: fit-content;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: none;\n  background-color: #dddddd;\n  padding: 10px;\n}\n\n#micNameInput {\n  width: 30vw;\n  height: 100%;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n#micManufacturerInput {\n  width: 30vw;\n  height: 100%;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n#micSerialNumberInput {\n  width: 30vw;\n  height: 100%;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n#modelNumberInput2 {\n  width: 30vw;\n  height: 100%;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n#modelNameInput2 {\n  width: 30vw;\n  height: 100%;\n  font-size: 1rem;\n  border-radius: 5px;\n  border: 1px solid black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n#loudspeakerInstructions2 {\n  font-size: 1rem;\n  font-weight: normal;\n  margin-top: 10px;\n}\n\n#completeTransducerTable {\n  border-collapse: collapse;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
